module.exports = __webpack_public_path__ + "100442ca3d3ab2dc920703e904f323b2.png";